import * as React from "react";

const SvgIcnAppleMessagesForBusiness = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M5.06173 17.5C4.3351 17.5 4.10935 16.8771 4.48325 16.3831C4.80071 15.9606 5.3933 15.1158 5.71076 14.4857C3.48148 13.4403 2 11.3568 2 9.00835C2 5.40692 5.55556 2.5 10 2.5C14.4444 2.5 18 5.40692 18 9.00835C18 12.7601 14.3104 15.6313 9.3933 15.4952C7.9612 16.5263 6.01411 17.5 5.06173 17.5ZM5.80247 16.3115C6.44444 16.0465 7.70018 15.2661 8.5679 14.6289C8.83598 14.4141 9.06173 14.3138 9.35803 14.321C9.64021 14.3282 9.85891 14.3353 10 14.3353C13.8095 14.3353 16.836 11.9439 16.836 9.00835C16.836 6.07995 13.8095 3.68854 10 3.68854C6.19753 3.68854 3.17108 6.07995 3.17108 9.00835C3.17108 10.92 4.44092 12.5883 6.65609 13.6337C7.10758 13.8484 7.15697 14.1778 6.95944 14.543C6.71958 15.0084 6.1552 15.753 5.76014 16.247C5.72487 16.29 5.74603 16.3329 5.80247 16.3115Z"
            fill="#0263E0"
        />
    </svg>
);

export default SvgIcnAppleMessagesForBusiness;
